import { styled } from '/imports/ui/foundation/Theme';

/**
 * This allows us to provide content that is read aloud by screen readers but not visually shown.
 */
export const VisuallyHidden = styled('span', () => ({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0,0,0,0)',
  whiteSpace: 'nowrap',
  borderWidth: 0,
}));
